<template>
	<member-list
		:adgroup="adgroup"
		:sort="sort"
		:sortDirection="sortDirection"
		:filters="{ keys: computeFilters }"></member-list>
</template>
<script>
	import { ref, inject, computed, onMounted } from "vue";
	import memberList from "@/components/webComponents/widget/memberList/memberList.vue";
	export default {
		components: {
			memberList
		},
		props: {
			json: {
				type: String,
				default: undefined
			},
			adgroup: {
				type: String,
				default: undefined
			},
			sort: {
				type: String,
				default: "lastName"
			},
			sortDirection: {
				type: String,
				default: "ASC"
			},
			pageFilters: {
				type: String,
				default: "{}"
			}
		},
		setup(props, context) {
			const $json = inject("$json");
			const moment = inject("$moment");
			const $http = inject("$http");

			const globalFilters = ref({});
			const filter = ref([]);

			if ($json.packed(props.json)) {
				filter.value = JSON.parse($json.unpack(props.json));
			} else {
				filter.value = JSON.parse(props.json || "[]");
			}

			if ($json.packed(props.pageFilters)) {
				globalFilters.value = JSON.parse($json.unpack(props.pageFilters));
			} else {
				globalFilters.value = JSON.parse(props.pageFilters || "{}");
			}

			const computeFilters = computed(() => {
				if (filter.value.length > 0) {
					return filter.value;
				} else if (globalFilters.value.UsersFilter.length > 0) {
					return globalFilters.value.UsersFilter;
				} else {
					return globalFilters.value.Parent?.UsersFilter || [];
				}
			});

			return {
				computeFilters
			};
		}
	};
</script>
